import { Component, OnDestroy, OnInit } from '@angular/core';
import { BasePageComponent } from '../base-page';
import { Store } from '@ngrx/store';
import { IAppState } from '../../interfaces/app-state';
import { HttpService } from '../../services/http/http.service';
import { Content } from '../../ui/interfaces/modal';
import { TCModalService } from '../../ui/services/modal/modal.service';
import Swal from 'sweetalert2'
import swal from 'sweetalert2'
import { HttpErrorResponse } from '@angular/common/http';
import {MainService 
} from './main.service'
import { Spinkit } from 'ng-http-loader'; // <============

// import { IOption } from '../../../../ui/interfaces/option';
@Component({
  selector: 'page-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  providers:[MainService]
})
export class MainPageComponentnt extends BasePageComponent implements OnInit, OnDestroy {
  restoID;
  data=[];
  public spinkit = Spinkit; 
  constructor(
    store: Store<IAppState>,
    httpSv: HttpService,
    private mainservice:MainService,
    private modal: TCModalService
  ) {
    super(store, httpSv);

    this.pageData = {
      title: '',
      loaded: true,
      breadcrumbs: [
        {
          title: 'Main',
         
        }
      ]
    };
  }

  ngOnInit() {
    this.restoID = sessionStorage.getItem('restoID');
    super.ngOnInit();
    // this.getdata();
    this.getrestoDetails();
   
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
  public file: any;
  public imageFile: any;
  restoDeatils = []
  mapOfExpandData: { [key: string]: boolean } = {};
  rstoName
  rstoID
  rstoAdd
  rstopocName
  pocID
  rstoEmail
  values
  restaurant_id
  switchs
  Acces
  mineActiveOrnot
  restoDeatilsMine = [];
  activetoggle
  algns:any=[]
  allArray:any=[]
  dietArray:any=[]
  dietPref=[]
  tagmultiple:any=[]
  tagArray=[]

  alrgOptionarray=[]
  alrgoption=[]
  dietOption=[];
  dietoptinarray=[]

  ingredience
  description
  food_dishes_price
  food_dishes_id
  food_dishes_restaurant_id
  errorMessage
  allergensWithCommaview
  dietpreference
  allergens=[]
  resto=[]
  food_dishes_name
  food_dishes_spice_rating
  food_dishes_calories
  food_dishes_category_id
  filesk={}
  currentAvatar
  tag_id
  dietPrefOp
  allergeOp
  tagview
  last_update
  restaurant_image
  messageFilesize
  // getdata() {
  //   this.httpSv.getReturant(this.restoID).subscribe(
  //     response => {
  //       if (response['status'] == true) {
  //         // Swal.fire("Password Successfully Changed")
  //         // this.router.navigate(['/public/sign-in']);
  //         // this.appointments = response.result.data;
  //         // this.router.navigate(['/public/sign-in']);
  //         this.resto = response['result'].data;
  //         this.rstoName = this.resto['restaurant_name']
  //         this.rstoID = this.resto['restaurant_unique_id']
  //         this.rstoAdd = this.resto['restaurant_address']
  //         this.rstopocName = this.resto['restaurant_poc_name']
  //         this.pocID = this.resto['restaurant_poc_number']
  //         this.rstoEmail = this.resto['restaurant_email']
  //         this.restaurant_id = this.resto['restaurant_id'];
  //         this.restaurant_image = this.resto['restaurant_image'];
  //         //  this.getrestoDetails();
  //       }
  //       else {
  //         // this.resetFormLoad = false;
  //         // Swal.fire("Something Went Wrong")
  //       }

  //     }
  //   )
  // }
  
  getrestoDetails() {
    this.httpSv.getReturantDetails(this.restoID).subscribe(
      response => {
        if (response['status'] == true) {

           this.restoDeatils = response['result'].data;
        }
        else {
          // this.resetFormLoad = false;
          Swal.fire("Something Went Wrong")
          this.restoDeatils
        }

      }
    ),
    (err: HttpErrorResponse) => {
      this.errorMessage = err;
      this.restoDeatils
      swal.fire({
          titleText: this.errorMessage, 
         timer: 2000,
         showCancelButton:false,
         showConfirmButton:false,
         position:"top-right",
        
       })
  }
  }
  allDiestpref=[]
  getDiestpref() {
    this.httpSv.getallDiestpref().subscribe(
      response => {
        if (response['status'] == true) {

          this.allDiestpref = response['result'].data;
        
        }
        else {
          // this.resetFormLoad = false;
           Swal.fire("Something Went Wrong")
        }

      }
    )
  }

  // getAllergens() {
  //   this.httpSv.getallAllergens().subscribe(
  //     response => {
  //       if (response['status'] == true) {
  //         this.allergens=response['result'].data;
        
              
  //       }
  //       else {
  //         // this.resetFormLoad = false;
  //          Swal.fire("Something Went Wrong")
  //       }

  //     }
  //   )
  // }
  categories=[]
  getCategory() {
    this.httpSv.getallCategory().subscribe(
      response => {
        if (response['status'] == true) {

          this.categories = response['result'].data;
        
        }
        else {
          // this.resetFormLoad = false;
           Swal.fire("Something Went Wrong")
        }

      }
    )
  }
  tags=[]
  getTag() {
    this.httpSv.getTag().subscribe(
      response => {
        if (response['status'] == true) {

          this.tags = response['result'].data;
        
        }
        else {
          // this.resetFormLoad = false;
           Swal.fire("Something Went Wrong")
        }

      }
    )
  }

  //getTag
  open(role){
    console.log(role)
  }

  // open modal window
  openModals<T>(body: Content<T>, header: Content<T> = null, footer: Content<T> = null,options: any = null,value) {
    this.modal.open({
      body: body,
      header: header,
      footer: footer,
      options: options
    });
  
    this.getCategory();
    // this.getAllergens();
    this.getDiestpref();
    this.getTag()
    // this.initPatientForm(row);
    this.algns=[]
    this.allArray=[]
    this.dietArray=[]
    this.dietPref=[]

    this.tagmultiple=[]
    this.tagArray=[]

    this.alrgOptionarray=[]
    this.alrgoption=[]
    this.dietOption=[];
    this.dietoptinarray=[]
  

    this.food_dishes_id=value.food_dishes_id;
    this.food_dishes_restaurant_id=value.food_dishes_restaurant_id
    this.food_dishes_name = value.food_dishes_name;
    this.food_dishes_price = value.food_dishes_price;
    this.food_dishes_spice_rating=value.food_dishes_spice_rating
    this.food_dishes_calories=value.food_dishes_calories
    this.food_dishes_category_id=value.food_dishes_category_id
    this.ingredience=value.food_dishes_ingredients
    this.description=value.food_dishes_details
    this.allArray=value.allergens
    this.tagmultiple=value.tagList;
    this.dietArray=value.diet_preference

    this.alrgOptionarray=value.allergensOption
    this.dietoptinarray=value.diet_preference_option;


    this.tagmultiple.forEach(element => {
      this.tagArray.push(element.tag_id)
  });

    this.allArray.forEach(element => {
      this.algns.push(element.allergens_id)
  });
  this.dietArray.forEach(element => {
    this.dietPref.push(element.diet_preference_id)
});


this.alrgOptionarray.forEach(element => {
  this.alrgoption.push(element.allergens_id)
});
this.dietoptinarray.forEach(element => {
this.dietOption.push(element.diet_preference_id)
});
  // console.log(this.algns.map(allergens_id => ({allergens_id})))

    // this.role=['7','10'];
} 



  openModalsView<T>(body: Content<T>, header: Content<T> = null, footer: Content<T> = null,options: any = null,value) {
    this.modal.open({
      body: body,
      header: header,
      footer: footer,
      options: options
    });
  
    this.getCategory();
    // this.getAllergens();
    this.getDiestpref();
    this.getTag()
    // this.initPatientForm(row);
    this.algns=[]
    this.allArray=[]
    this.dietArray=[]
    this.dietPref=[]
    this.dietpreference=value.dpWithComma
    this.allergensWithCommaview=value.allergensWithComma
    this.food_dishes_id=value.food_dishes_id;
    this.food_dishes_restaurant_id=value.food_dishes_restaurant_id
    this.food_dishes_name = value.food_dishes_name;
    this.food_dishes_price = value.food_dishes_price;
    this.food_dishes_spice_rating=value.food_dishes_spice_rating
    this.food_dishes_calories=value.food_dishes_calories
    this.food_dishes_category_id=value.food_dishes_category_id
    this.tag_id=value.tag_id
    this.last_update=value.updated_on
    this.ingredience=value.food_dishes_ingredients
    this.description=value.food_dishes_details
    this.allArray=value.allergens
    this.dietPrefOp=value.dpoWithComma 
    this.allergeOp=value.allergensOptionWithComma
    this.tagview=value.tagWithComma
    this.allArray.forEach(element => {
      this.algns.push(element.allergens_id)
  });
  this.dietArray=value.diet_preference
  this.dietArray.forEach(element => {
    this.dietPref.push(element.diet_preference_id)
});
  }


  closeModal() {
    this.modal.close();
  }
  dishes_id
  openModal<T>(body: Content<T>, header: Content<T> = null, footer: Content<T> = null, value) {
    this.dishes_id=value;
   
    this.modal.open({
      body: body,
      header: header,
      footer: footer,
    });
   
  }

  closeModals() {
    this.modal.close();
  }
  openModalImage<T>( header: Content<T> = null, body: Content<T>,footer: Content<T> = null,value) {
    this.currentAvatar=""
    this.food_dishes_id=value.food_dishes_id;
       this.modal.open({
      body: body,
      header: header,
      footer: footer,
    });
   
  }

  // switch(valueStatus, valueId) {
   
  //   this.httpSv.AcitveInactiveDish(valueStatus, this.restaurant_id, valueId).subscribe(
  //     response => {
  //       if (response['status'] == true) {
  //         this.modal.close();
          
  //         swal.fire({
  //           titleText: response['message'], 
  //          timer: 2000,
  //          showCancelButton:false,
  //          showConfirmButton:false,
  //          position:"top-right",
  //        })

         

  //         this.getrestoDetails()
  //       }
  //       else {
  //         // this.resetFormLoad = false;
  //          Swal.fire("Something Went Wrong")
  //       }

  //     },
  //     (err: HttpErrorResponse) => {
  //       this.errorMessage = err;
  //       this.modal.close();
  //       swal.fire({
  //         titleText: this.errorMessage, 
  //        timer: 2000,
  //        showCancelButton:false,
  //        showConfirmButton:false,
  //        position:"top-right",
  //      })
  //   }
  //   )
  // }
  deleteDish() {
    this.httpSv.deleteDish(this.dishes_id, this.restaurant_id).subscribe(
      response => {
        if (response['status'] == true) {
          this.modal.close();
          swal.fire({
            titleText: response['message'], 
           timer: 2000,
           showCancelButton:false,
           showConfirmButton:false,
           position:"top-right",
         })

          this.getrestoDetails()
        }
        else {
          // this.resetFormLoad = false;
          // Swal.fire("Something Went Wrong")
        }

      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err;
        this.modal.close();
        swal.fire({
          titleText: this.errorMessage, 
         timer: 2000,
         showCancelButton:false,
         showConfirmButton:false,
         position:"top-right",
       })
    }
    )
  }

  updateDish() {
    this.httpSv.deleteDish(this.values, this.restaurant_id).subscribe(
      response => {
        if (response['status'] == true) {
          this.modal.close();
          swal.fire({
           titleText: response['message'], 
          timer: 2000,
          showCancelButton:false,
          showConfirmButton:false,
          position:"top-right",
         
          
        })

          this.getrestoDetails()
        }
        else {
          // this.resetFormLoad = false;
          // Swal.fire("Something Went Wrong")
        }

      },
      (err: HttpErrorResponse) => {
        this.modal.close();
        this.errorMessage = err;
        swal.fire({
          titleText: this.errorMessage, 
         timer: 2000,
         showCancelButton:false,
         showConfirmButton:false,
         position:"top-right",
       })
    }
    )
  }

  aalreges
  dietPrefs
  tagsadd
  alergoption
  dietprefoption
  updateList(food_dishes_name,food_dishes_price,food_dishes_spice_rating,
    food_dishes_calories,food_dishes_category_id,algns,dietPref,Ingredience,Description,tagArray,alrgoption,dietOption) {
  // console.log(this.algns.map(allergens_id => ({allergens_id})))
    this.aalreges=algns.map(allergens_id => ({allergens_id}))
    this.dietPrefs=dietPref.map(diet_preference_id => ({diet_preference_id}))
    this.tagsadd=tagArray.map(tag_id => ({tag_id}))
    this.alergoption=alrgoption.map(allergens_id => ({allergens_id}))
    this.dietprefoption=dietOption.map(diet_preference_id => ({diet_preference_id}))

    const data={
      food_dishes_id: this.food_dishes_id,
      food_dishes_restaurant_id: this.food_dishes_restaurant_id,       
      food_dishes_category_id:food_dishes_category_id,
      food_dishes_name: food_dishes_name,
      food_dishes_details:Description,
      food_dishes_ingredients:Ingredience,
      food_dishes_price: food_dishes_price,
      food_dishes_calories:food_dishes_calories,
      food_dishes_spice_rating:food_dishes_spice_rating,                    
      allergens: this.aalreges,
      diet_preference: this.dietPrefs,
      taglist:this.tagsadd,
      allergens_option_available:this.alergoption,
      dietry_preference_option:this.dietprefoption
  }
    this.httpSv.updateList(data).subscribe(
      response => {
        if (response['status'] == true) {
          this.modal.close();
          swal.fire({
           titleText: response['message'], 
          timer: 2000,
          showCancelButton:false,
          showConfirmButton:false,
          position:"top-right",
         
          
        })

          this.getrestoDetails()
        }
        else {
          // this.resetFormLoad = false;
          // Swal.fire("Something Went Wrong")
        }

      },
      (err: HttpErrorResponse) => {
        this.modal.close();
        this.errorMessage = err;
        swal.fire({
          titleText: this.errorMessage, 
         timer: 2000,
         showCancelButton:false,
         showConfirmButton:false,
         position:"top-right",
       })
    }
    )
  }

  noRecordMsgFlag: boolean;
  isEmpty(event) {
    console.log(event);
    if (event.filteredValue.length == 0) {
      this.noRecordMsgFlag = true;
    } else {
      this.noRecordMsgFlag = false;
    }
  }

  openModalFile<T>(header: Content<T> = null,body: Content<T>,  footer: Content<T> = null,options: any = null) {
    // this.dishes_id=value;
   
    this.modal.open({
      body: body,
      header: header,
      footer: footer,
      options:options
    });
   
  }
  formatData
  onCSVChange(event){
    if (event.target.files && event.target.files[0]) {
      this.filesk = event.target.files[0];
        //  this.formatData = new FormData();
        //  this.formatData.append('file',event.target.files[0]);
        //  this.formatData.append('id',this.restaurant_id);
       // this.uploadCsv(formatData)
    }
}

uploadCsv(){
  this.mainservice.addList(this.restaurant_id,this.filesk).subscribe(
    response => {
      if (response['status'] == true) {
        this.modal.close();
        // Swal.fire(response['message']);
        swal.fire({
           titleText: response['message'], 
          timer: 2000,
          showCancelButton:false,
          showConfirmButton:false,
          position:"top-right",
        })
        this.getrestoDetails()
      }
      else {
        // this.resetFormLoad = false;
        // Swal.fire("Something Went Wrong")
      }

    },
    (err: HttpErrorResponse) => {
      this.errorMessage = err;
      swal.fire({
          titleText: this.errorMessage, 
         timer: 2000,
         showCancelButton:false,
         showConfirmButton:false,
         position:"top-right",
       })
      this.modal.close();
  }
  )
}

downloadTemplate(){
  this.httpSv.getCsvTempData().subscribe(
      response => {
          if(response){
              // this.toasterService.success(response["message"], "success");
              let csvFile = response['result'].data.url;
              this.downloadFile(csvFile);
          }
      },
      (err: HttpErrorResponse) => {
          this.errorMessage = err;
          // this.toasterService.warning(this.errorMessage);
      }
  );
}
downloadFile(urlData) {
  var aLink = document.createElement('a');
  aLink.href = urlData;
  var event = new MouseEvent('click');
  aLink.dispatchEvent(event);
  aLink.remove();
}

  // upload new file
  onImageChange(event){
   
    if (event.target.files && event.target.files[0]) {
      const fsize = event.target.files[0].size; 
      const fileSize = Math.round((fsize / 1024));
      if(fileSize < 2048){
        this.imageFile = new FormData();
        this.imageFile.append('file',event.target.files[0]);
        this.imageFile.append('id',this.restaurant_id);
        this.imageFile.append('dish_id',this.food_dishes_id);
        let file: File = event.target.files[0];
        let reader: FileReader = new FileReader();
        this.messageFilesize=""
        reader.onloadend = () => {
          this.currentAvatar = reader.result;
        };
    
        reader.readAsDataURL(file);
    }
    else{
      this.messageFilesize="File too Big, please select a file less than 2mb"
    
    }
      }
     
}

uploadImage(){
  this.httpSv.addImage(this.imageFile).subscribe(
    response => {
      if (response['status'] == true) {
        this.modal.close();
        // Swal.fire(response['message']);
        swal.fire({
           titleText: response['message'], 
          timer: 2000,
          showCancelButton:false,
          showConfirmButton:false,
          position:"top-right",
        })
        this.getrestoDetails()
      }
      else {
        // this.resetFormLoad = false;
        // Swal.fire("Something Went Wrong")
      }

    },
    (err: HttpErrorResponse) => {
      this.errorMessage = err;
      swal.fire({
          titleText: this.errorMessage, 
         timer: 2000,
         showCancelButton:false,
         showConfirmButton:false,
         position:"top-right",
       })
      this.modal.close();
  }
  )

}


}


